<template>
  <div class="dish-showcase">
    <!-- 侧边分类菜单 -->
    <div class="sidebar">
      <div class="sidebar-title">菜品分类</div>
      <ul class="category-list">
        <li><router-link to="/cp/mycp1" exact-active-class="active">荤菜</router-link></li>
        <li><router-link to="/cp/mycp5">半荤菜</router-link></li>
        <li><router-link to="/cp/mycp2">素菜</router-link></li>
        <li><router-link to="/cp/mycp3">主食甜点</router-link></li>
        <li><router-link to="/cp/mycp4">精品小吃</router-link></li>
      </ul>
    </div>

    <!-- 菜品网格区域 -->
    <div class="dish-grid">
      <div class="dish-card" v-for="(dish, idx) in dishList" :key="idx">
        <el-image
          class="dish-img"
          :src="dish.thumb"
          :preview-src-list="[dish.preview]"
          fit="cover"
        >
          <div slot="error" class="error-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="dish-info">
          <span class="dish-name">{{ dish.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dishList: [
        { name: '川香麻花鸡', thumb: require('../../assets/cp/jbc/hc/01.jpg'), preview: require('../../assets/cp/jbc/hc/01-big.jpg') },
        { name: '白斩鸡', thumb: require('../../assets/cp/jbc/hc/02.jpg'), preview: require('../../assets/cp/jbc/hc/02-big.jpg') },
        { name: '葱烧鱿鱼', thumb: require('../../assets/cp/jbc/hc/03.jpg'), preview: require('../../assets/cp/jbc/hc/03-b.jpg') },
        { name: '大脸鸡排', thumb: require('../../assets/cp/jbc/hc/04.jpg'), preview: require('../../assets/cp/jbc/hc/04-b.jpg') },
        { name: '大盘鸡', thumb: require('../../assets/cp/jbc/hc/05.jpg'), preview: require('../../assets/cp/jbc/hc/05-b.jpg') },
        { name: '东坡肉', thumb: require('../../assets/cp/jbc/hc/06.jpg'), preview: require('../../assets/cp/jbc/hc/06-b.jpg') },
        { name: '豆豉蒸排骨', thumb: require('../../assets/cp/jbc/hc/07.jpg'), preview: require('../../assets/cp/jbc/hc/07-b.jpg') },
        { name: '番茄焖牛腩', thumb: require('../../assets/cp/jbc/hc/08.jpg'), preview: require('../../assets/cp/jbc/hc/08-b.jpg') },
        { name: '风味鳕鱼快', thumb: require('../../assets/cp/jbc/hc/09.jpg'), preview: require('../../assets/cp/jbc/hc/09-b.jpg') },
        { name: '干炸带鱼', thumb: require('../../assets/cp/jbc/hc/10.jpg'), preview: require('../../assets/cp/jbc/hc/10-b.jpg') },
        { name: '锅包肉', thumb: require('../../assets/cp/jbc/hc/11.jpg'), preview: require('../../assets/cp/jbc/hc/11-b.jpg') },
        { name: '黑椒牛柳', thumb: require('../../assets/cp/jbc/hc/12.jpg'), preview: require('../../assets/cp/jbc/hc/12-b.jpg') },
        { name: '黑椒牛仔粒', thumb: require('../../assets/cp/jbc/hc/13.jpg'), preview: require('../../assets/cp/jbc/hc/13-b.jpg') },
        { name: '回锅肉', thumb: require('../../assets/cp/jbc/hc/14.jpg'), preview: require('../../assets/cp/jbc/hc/14-b.jpg') },
        { name: '茴香大虾', thumb: require('../../assets/cp/jbc/hc/15.jpg'), preview: require('../../assets/cp/jbc/hc/15-b.jpg') },
        { name: '扒皮鱼', thumb: require('../../assets/cp/jbc/hc/47.jpg'), preview: require('../../assets/cp/jbc/hc/47-b.jpg') },
        { name: '金汤肥牛', thumb: require('../../assets/cp/jbc/hc/17.jpg'), preview: require('../../assets/cp/jbc/hc/17-b.jpg') },
        { name: '金汤鱼', thumb: require('../../assets/cp/jbc/hc/18.jpg'), preview: require('../../assets/cp/jbc/hc/18-b.jpg') },
        { name: '扣碗小酥肉', thumb: require('../../assets/cp/jbc/hc/19.jpg'), preview: require('../../assets/cp/jbc/hc/19-b.jpg') },
        { name: '卤水大骨头', thumb: require('../../assets/cp/jbc/hc/20.jpg'), preview: require('../../assets/cp/jbc/hc/20-b.jpg') },
        { name: '卤水鸡腿', thumb: require('../../assets/cp/jbc/hc/21.jpg'), preview: require('../../assets/cp/jbc/hc/21-b.jpg') },
        { name: '萝卜炖牛腩', thumb: require('../../assets/cp/jbc/hc/22.jpg'), preview: require('../../assets/cp/jbc/hc/22-b.jpg') },
        { name: '麻辣鸡腿', thumb: require('../../assets/cp/jbc/hc/23.jpg'), preview: require('../../assets/cp/jbc/hc/23-b.jpg') },
        { name: '麻辣鸭腿', thumb: require('../../assets/cp/jbc/hc/24.jpg'), preview: require('../../assets/cp/jbc/hc/24-b.jpg') },
        { name: '麻辣猪手', thumb: require('../../assets/cp/jbc/hc/25.jpg'), preview: require('../../assets/cp/jbc/hc/25-b.jpg') },
        { name: '毛血旺', thumb: require('../../assets/cp/jbc/hc/26.jpg'), preview: require('../../assets/cp/jbc/hc/26-b.jpg') },
        { name: '梅干菜瘦肉', thumb: require('../../assets/cp/jbc/hc/27.jpg'), preview: require('../../assets/cp/jbc/hc/27-b.jpg') },
        { name: '闷罐肉', thumb: require('../../assets/cp/jbc/hc/28.jpg'), preview: require('../../assets/cp/jbc/hc/28-b.jpg') },
        { name: '焖锅肉', thumb: require('../../assets/cp/jbc/hc/29.jpg'), preview: require('../../assets/cp/jbc/hc/29-b.jpg') },
        { name: '农家小炒肉', thumb: require('../../assets/cp/jbc/hc/30.jpg'), preview: require('../../assets/cp/jbc/hc/30-b.jpg') },
        { name: '青椒鸡片', thumb: require('../../assets/cp/jbc/hc/31.jpg'), preview: require('../../assets/cp/jbc/hc/31-b.jpg') },
        { name: '清蒸鱼块', thumb: require('../../assets/cp/jbc/hc/32.jpg'), preview: require('../../assets/cp/jbc/hc/32-b.jpg') },
        { name: '手抓排骨', thumb: require('../../assets/cp/jbc/hc/34.jpg'), preview: require('../../assets/cp/jbc/hc/34-b.jpg') },
        { name: '四喜丸子', thumb: require('../../assets/cp/jbc/hc/35.jpg'), preview: require('../../assets/cp/jbc/hc/35-b.jpg') },
        { name: '糖醋里脊', thumb: require('../../assets/cp/jbc/hc/37.jpg'), preview: require('../../assets/cp/jbc/hc/37-b.jpg') },
        { name: '土耳其烤肉', thumb: require('../../assets/cp/jbc/hc/38.jpg'), preview: require('../../assets/cp/jbc/hc/38-b.jpg') },
        { name: '五香鸡爪', thumb: require('../../assets/cp/jbc/hc/40.jpg'), preview: require('../../assets/cp/jbc/hc/40-b.jpg') },
        { name: '香水鱼', thumb: require('../../assets/cp/jbc/hc/41.jpg'), preview: require('../../assets/cp/jbc/hc/41-b.jpg') },
        { name: '湘味腰花', thumb: require('../../assets/cp/jbc/hc/42.jpg'), preview: require('../../assets/cp/jbc/hc/42-b.jpg') },
        { name: '蒸小酥肉', thumb: require('../../assets/cp/jbc/hc/43.jpg'), preview: require('../../assets/cp/jbc/hc/43-b.jpg') },
        { name: '油焖大虾', thumb: require('../../assets/cp/jbc/hc/44.jpg'), preview: require('../../assets/cp/jbc/hc/44-b.jpg') },
        { name: '时蔬虾球', thumb: require('../../assets/cp/jbc/bhc/11.jpg'), preview: require('../../assets/cp/jbc/bhc/11-b.jpg') },
        { name: '土豆炖鸡块', thumb: require('../../assets/cp/jbc/bhc/12.jpg'), preview: require('../../assets/cp/jbc/bhc/12-b.jpg') },
        { name: '土豆红烧肉', thumb: require('../../assets/cp/jbc/bhc/13.jpg'), preview: require('../../assets/cp/jbc/bhc/13-b.jpg') },
      ]
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.dish-showcase {
  max-width: 80%;
  margin: 30px auto;
  padding: 0 20px;
  display: flex;
  gap: 30px;
}

/* 侧边菜单 */
.sidebar {
  width: 220px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  height: fit-content;
}
.sidebar-title {
  background: linear-gradient(135deg, #f97316, #facc15);
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  padding: 16px 0;
  letter-spacing: 2px;
}
.category-list {
  list-style: none;
  padding: 12px 0;
}
.category-list li {
  margin: 0;
}
.category-list a {
  display: block;
  padding: 12px 24px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  color: #4a5568;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}
.category-list a:hover {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  padding-left: 28px;
}
.category-list a.active {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  font-weight: 600;
}

/* 菜品网格 */
.dish-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 24px;
}
.dish-card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s, box-shadow 0.25s;
}
.dish-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 28px -12px rgba(0, 0, 0, 0.15);
}
.dish-card:hover .dish-info {
  background: #b03e45;
}
.dish-card:hover .dish-info .dish-name {
  color:#fff;
}
.dish-img {
  width: 100%;
  height: 200px;
  display: block;
  background: #f0f0f0;
}
.dish-img /deep/ img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s;
}
.dish-card:hover .dish-img /deep/ img {
  transform: scale(1.03);
}
.dish-info {
  padding: 14px 16px 18px;
  text-align: center;
  background: #fff;
}
.dish-name {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  letter-spacing: 1px;
}
.error-slot {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #cbd5e0;
}

</style>